import { Text } from '@/atoms';
import { Blok } from '@/bloks/Blok';
import { LinkButton, LinkButtonProps } from '@/bloks/Button';
import { GlobalMenuLinkGroupStoryblok, GlobalMenuSpaceStoryblok } from '@/components';
import { cls } from '@/utils';
import styles from './LinkGroup.module.scss';

interface BlokProps {
	blok: GlobalMenuLinkGroupStoryblok;
}

export const blokProps = ({ blok }: BlokProps): Props => ({
	title: blok.title,
	links: blok.links?.map((item) => {
		if (item.component === 'LinkButton') {
			return LinkButton.blokProps({ blok: item });
		}

		return item as GlobalMenuSpaceStoryblok;
	}),
	_uid: blok._uid,
});

interface Props {
	title?: string;
	links?: (LinkButtonProps | GlobalMenuSpaceStoryblok)[];
	_uid: string;
	main?: boolean;
	tabIndex?: number;
	className?: string;
}

export const LinkGroup: Blok<Props, BlokProps> = ({ title, links, main, tabIndex, className }) => {
	return (
		<div className={cls(styles.linkGroup, styles[`type--${main ? 'main' : 'sub'}`], className)}>
			<Text marginBottom="075" size="small">
				{title}
			</Text>
			<div className={styles.links}>
				{links?.map((item) => {
					if (item.component === 'LinkButton') {
						return (
							<LinkButton
								key={item._uid}
								{...item}
								variant="link"
								size={main ? 'large' : 'medium'}
								tabIndex={tabIndex}
							/>
						);
					}
					if (item.component === 'GlobalMenuSpace') {
						return <div className={styles.space} key={item._uid} />;
					}
				})}
			</div>
		</div>
	);
};

LinkGroup.blokProps = blokProps;
